export default __webpack_public_path__ + "static/media/Hungrybox.a00f0018.jpg";